import { Injectable } from '@angular/core';
import { databases, ID } from '../config/appwrite';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReferidosService {

  private collectionId = "t_referidos";
  private DATABASE_NAME = environment.databaseName;

  constructor() { }


  getTiposReferidos(){
    return databases.listDocuments(
      this.DATABASE_NAME,
      this.collectionId
    );
  }

}
